
import { Component, ElementRef, Input, OnInit, ViewChild, OnChanges, DoCheck } from '@angular/core';
import {MatPaginatorModule, MatPaginator, MatSort, MatTableDataSource, MatDialog} from '@angular/material';
import {MatRadioModule} from '@angular/material/radio';

import {SelectionModel, DataSource} from '@angular/cdk/collections';
import { HttpClient } from "@angular/common/http";
import { FileUploader } from 'ng2-file-upload';
import * as moment from "moment";
import { environment } from "environments/environment";

import { AdminGuardService } from '../../../servicios/guards/admin-guard.service';

import { NgForm, FormGroup, FormControl, Validators, FormsModule  } from '@angular/forms';
import { formatDate, DatePipe } from '@angular/common';
import * as XLSX from 'xlsx';
import { element } from 'protractor';
import { componentRefresh } from '@angular/core/src/render3/instructions';
import { stringify } from '@angular/compiler/src/util';

//snackbar 1
import {MatSnackBar} from '@angular/material';
import { duration } from 'moment';

export interface PeriodicElement {
  position:number;
  USUARIO: string;
  SEC_DEL: string;
  CODIGO: string;
  CATEGORIA: string;
  DETALLE: number;
  IMPORTE: string;
  OBSERVACIONES: string;
  FECHA_MODIFICACION: string;
}

var ELEMENT_DATA: PeriodicElement[] = [];
var ELEMENT_DATA2: PeriodicElement[] = [];

@Component({
  selector: 'app-vergastos-pagos',
  templateUrl: './vergastos-pagos.component.html',
  styleUrls: ['./vergastos-pagos.component.css']
})




export class VergastosPagosComponent implements OnInit, DoCheck {

  @ViewChild('TABLE') table: ElementRef;

  displayedColumns: string[] = ['select', 'CODIGO','USUARIO','SEC_DEL', 'CATEGORIA', 'DETALLE', 'IMPORTE', 'OBSERVACIONES', 'FECHA_MODIFICACION'];
  dataSource = new MatTableDataSource(ELEMENT_DATA);
  dataSource2 = new MatTableDataSource(ELEMENT_DATA2);

  @ViewChild(MatSort) sort: MatSort;
  
  @ViewChild(MatPaginator) paginator: MatPaginator;
  

  selection = new SelectionModel<PeriodicElement>(true, []);
  selectedDate;
  suma;
  codi_edit: number;
  detallegasto_edit;
  det_edit;
  tot_edit;
  USER;
  CATEGORIA;
  EST;
  result;
  idsec;
  loading;



  constructor(
    private http: HttpClient,
    public dialog: MatDialog,
    //snackbar 2
    public snackBar: MatSnackBar
  ){
    //this.loading=true; 

   }

   estadoElegido: string;
   estados: string[] = ['PENDIENTE', 'AUTORIZADO'];
   ngDoCheck(){
     //asigno el valor de los option-select al local para que al volver al formulario, sigan cargados como seleccoino el usuario
     localStorage.setItem("verpagoscatego",this.CATEGORIA);
     localStorage.setItem("verpagosuser",this.USER);
     localStorage.setItem("verpagosestado",this.EST);
     console.log("changues!");
    
     localStorage.setItem('estadoElegido',this.estadoElegido);
     //this.calculaUsuarios();
   }

   
  selectRow(row, detalle, imp) {
    this.codi_edit = row;
    this.det_edit = detalle;
    this.tot_edit = imp;

    console.log(this.codi_edit);
    console.log(this.det_edit);
  }


  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  //Si el número de elementos seleccionados coincide con el número total de filas..
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  //Selecciona todas las filas si no están todas seleccionadas; de lo contrario, borra la seleccion
  masterToggle() {
    this.isAllSelected() ?
        this.selection.clear() :
        this.dataSource.data.forEach(row => this.selection.select(row));
  }
  
  addEvent(input: string, $event) {
    this.selectedDate = moment($event.value).format('YY-MM-DD');
  }



  ngOnInit() {
    window.scroll(0,0);
    this.noti = localStorage.getItem('notipend');
    this.idsec=this.idsec=localStorage.getItem('seccional');
    //calculo usuarios para el option
    //this.calculaUsuarios();

    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    console.log(localStorage.getItem('verpagoscatego'));
    console.log(localStorage.getItem('verpagosuser'));
    console.log(localStorage.getItem('verpagosestado'));
    
    //CASO QUE VUELVO DE CONSULTAR UN DETALLE Y QUEDA TODO TAL CUAL ESTABA 
    //opciones llenas, vuelve de consulta y sigue los valores preestablecidos
    /*
    if (localStorage.getItem('verpagoscatego') != null && localStorage.getItem('verpagosuser') !=null && localStorage.getItem('verpagosestado') != null){
    
      this.CATEGORIA = localStorage.getItem('verpagoscatego');
      this.USER = localStorage.getItem('verpagosuser');
      this.EST = localStorage.getItem('verpagosestado');
      
      
      setTimeout(() => {
        console.log("cargando grid.. post ver detalles!");
        this.http.get(`${environment.backendUrl}/api/vergastospagos/ver?cate=${localStorage.getItem('verpagoscatego')}
              &id_user=${localStorage.getItem('verpagosuser')}&estado=${localStorage.getItem('verpagosestado')}`)
              .subscribe((data: any[]) => {
                this.dataSource.data = data;
              });
      }, 1000);
      
      console.log("local precargado..");
    }else{
      //opciones vacias
      console.log("0km..");
    }
    */

  }

  exportAsExcel() {
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(this.table.nativeElement);//converts a DOM TABLE element to a worksheet
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, `Gastos-${localStorage.getItem('apellidonombre')}_viaje.xlsx`);
  }

  getImporteTotal() {
    
  }

  enviarCodGasto(){
    //al hacer click en editar en el modal, envio al local storage el codigo de gasto a editar
    localStorage.setItem('codgasto_edit', `${this.codi_edit}`);
    localStorage.setItem('detallegasto_edit', `${this.det_edit}`);  
    console.log(localStorage.getItem('codgasto_edit'));
    localStorage.setItem('imp_gasto',`${this.tot_edit}`);
  }
//boton conssultar! llena grid
  buscarFiltros(){
    this.loading=true;
    //this.CATEGORIA="VIAJE";
    //this.EST="PENDIENTE";
    this.http.get(`${environment.backendUrl}/api/vergastospagos/ver?cate=${this.CATEGORIA}&id_user=${this.USER}&estado=${this.estadoElegido}`)
    .subscribe((data: any[]) => {
      this.dataSource.data = data;
      this.loading=false;  
    });
  }

  //llena el option de usuarios (pendientes)
  calculaUsuarios(){
    this.loading=true;
    this.http.get(`${environment.backendUrl}/api/calculausers/usuarios_dispo?idsec=${this.idsec}&estado=${this.estadoElegido}`)
    .subscribe((data: any[]) => {
      this.dataSource2.data = data; 
      console.log(this.dataSource2.data);
      console.log(this.estadoElegido); 
      this.loading=false;
      this.dataSource.data=[];
    });
  }

  autorizarGasto(){
    this.loading=true;
    this.http.get(`${environment.backendUrl}/api/autorizargasto/autorizar?codgas=${this.codi_edit}&est=AUTORIZADO`)
    .subscribe((data: any) => {
      this.result = JSON.stringify(data["affectedRows"]);
      if (this.result==1){
        console.log(`GASTO COD: ${this.codi_edit} AUTORIZADO CORRECTAMENTE!`);
        this.buscarFiltros();
        this.llenarNoti();
        this.calculaUsuarios();
        window.scroll(0,0);
        this.loading=false;
        
        // snackbar gasto autorizado
        this.snackBar.open(`GASTO [${this.codi_edit}] AUTORIZADO CORRECTAMENTE!`, 'Cerrar', {duration: 3000});
      
      }else{
        console.log(`el COD: ${this.codi_edit} no existe en la bd!`)
      }
    });
  }

  noti;  
  llenarNoti(){
    //http://localhost:1337/api/notifi/noti?idse=21&est=PENDIENTE
    this.http.get(`${environment.backendUrl}/api/notifi/noti?idse=${this.idsec}&est=PENDIENTE`)
    .subscribe((data: any[]) => {
      this.noti = data[0]["TOT"]; 
      localStorage.setItem('notipend',this.noti);
      console.log(`noti= ${localStorage.getItem('notipend')}`); 
    });

  }

  rechazarGasto(){
    this.http.get(`${environment.backendUrl}/api/autorizargasto/autorizar?codgas=${this.codi_edit}&est=RECHAZADO`)
    .subscribe((data: any) => {
      this.result = JSON.stringify(data["affectedRows"]);
      if (this.result==1){
        console.log(`GASTO COD: ${this.codi_edit} RECHAZADO CORRECTAMENTE!`);
        this.buscarFiltros();
      }else{
        console.log(`el COD: ${this.codi_edit} no existe en la bd!`)
      }
    });
  }

}


